import React, { useEffect, useState } from 'react';
import { logAuthFailure } from '../services/PreAuthLogService';
import { useNavigate } from 'react-router-dom';
import { sendEmailVerification } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { useAuth } from '../contexts/AuthContext';

const EmailVerificationPendingPage = () => {
  const { currentUser, logout, refreshEmailVerification } = useAuth();
  const navigate = useNavigate();
  const [resendSent, setResendSent] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendError, setResendError] = useState('');

  // Polling toutes les 5s : détecte la vérification dans un autre onglet/appareil
  useEffect(() => {
    const interval = setInterval(async () => {
      const verified = await refreshEmailVerification();
      if (verified) {
        clearInterval(interval);
        navigate('/first-login', { replace: true });
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [refreshEmailVerification, navigate]);

  const handleResend = async () => {
    if (!auth.currentUser || resendLoading) return;
    setResendLoading(true);
    setResendError('');
    try {
      await sendEmailVerification(auth.currentUser, {
        url: 'https://drumigo.com/login?verified=1'
      });
      setResendSent(true);
      setTimeout(() => setResendSent(false), 6000);
    } catch (e) {
      console.error('Erreur renvoi email:', e);
      logAuthFailure('verification_resend_page', e);
      setResendError('Impossible de renvoyer l\'email. Réessaie dans quelques secondes.');
    } finally {
      setResendLoading(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 p-4">
      <div className="bg-slate-800/60 backdrop-blur-xl border border-white/10 p-8 rounded-2xl shadow-2xl w-full max-w-md text-center">
        <div className="text-5xl mb-4">📬</div>
        <h1 className="text-2xl font-bold text-amber-50 mb-2">Vérifie ta boîte mail</h1>

        <p className="text-slate-400 text-sm mb-1">
          Un email de vérification a été envoyé à
        </p>
        <p className="text-amber-300 font-semibold text-sm mb-5 break-all">
          {currentUser?.email}
        </p>

        <p className="text-slate-400 text-sm mb-8 leading-relaxed">
          Clique sur le lien dans l'email pour accéder à ton compte.
          Cette page se mettra à jour automatiquement.
        </p>

        <div className="flex flex-col gap-3">
          {resendSent ? (
            <div className="bg-green-900/40 border border-green-500/50 text-green-300 px-4 py-2 rounded-xl text-sm">
              Email renvoyé !
            </div>
          ) : (
            <button
              onClick={handleResend}
              disabled={resendLoading}
              className="w-full py-2.5 rounded-full font-semibold text-white bg-gradient-to-r from-amber-500 to-orange-600 hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {resendLoading ? 'Envoi...' : 'Renvoyer l\'email'}
            </button>
          )}

          {resendError && (
            <p className="text-red-400 text-xs">{resendError}</p>
          )}

          <button
            onClick={handleLogout}
            className="text-slate-500 hover:text-slate-300 text-sm transition-colors mt-2"
          >
            Me déconnecter
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationPendingPage;
